module.exports = __webpack_public_path__ + "media/images/banner-prepaid-bundles-2fd8c90c7342ec52b892fc9325261b8f.jpg";